import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as I from "react";
import { c as w } from "./index.CxSWpsOB.js";
const J = {
  24: "xs",
  40: "sm",
  56: "md"
}, q = {
  40: "sm",
  56: "md"
}, j = {
  xs: "tw-size-24",
  sm: "tw-size-40",
  md: "tw-size-56"
}, N = {
  xs: "tw-size-12",
  sm: "tw-size-16",
  md: "tw-size-24"
}, S = {
  xs: "[&_svg]:tw-size-16",
  sm: "[&_svg]:tw-size-24",
  md: "[&_svg]:tw-size-32"
}, _ = {
  md: "tw-size-56 tw-gap-8 tw-p-[6px]",
  sm: "tw-size-40 tw-gap-[5.714px] tw-p-[4.286px]"
}, y = {
  md: "tw-size-[44px]",
  sm: "tw-size-[31.429px]"
}, A = {
  md: "tw-box-border tw-flex tw-size-56 tw-shrink-0 tw-items-center tw-justify-end tw-pt-6 tw-pr-2 tw-pb-2 tw-pl-6",
  sm: "tw-box-border tw-flex tw-size-40 tw-shrink-0 tw-items-center tw-justify-end tw-pt-[4.286px] tw-pr-[1.143px] tw-pb-[1.143px] tw-pl-[4.286px]"
}, C = {
  md: "tw-relative tw-size-48 tw-shrink-0",
  sm: "tw-relative tw-size-[34.286px] tw-shrink-0"
}, M = {
  md: "tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-z-10 tw-flex tw-size-24 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-circular tw-border tw-border-solid tw-border-base-white tw-bg-gray-200",
  sm: "tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-z-10 tw-flex tw-size-[17.143px] tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-circular tw-border tw-border-solid tw-border-base-white tw-bg-gray-200"
}, T = {
  md: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-py-4 tw-px-[3px]",
  sm: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-py-3 tw-px-[2.14px]",
  xs: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-[1.71px] tw-px-[1.29px]"
}, $ = {
  md: "tw-h-[46.411px] tw-w-[48.947px]",
  sm: "tw-h-[33.15px] tw-w-[34.96px]",
  xs: "tw-h-[19.89px] tw-w-[20.98px]"
}, E = [{
  translateX: "-54%",
  translateY: "-53%",
  rotateDeg: -8,
  overlay: !1
}, {
  translateX: "-46%",
  translateY: "-47%",
  rotateDeg: 4,
  overlay: !0
}], u = [1, 0], B = {
  md: "tw-flex tw-items-center tw-justify-center tw-pt-[5px] tw-pr-[0.389px] tw-pb-[1.822px] tw-pl-0",
  sm: "tw-flex tw-items-center tw-justify-center tw-pt-4 tw-pr-0 tw-pb-2 tw-pl-0",
  xs: "tw-flex tw-items-center tw-justify-center tw-pt-2 tw-pr-0 tw-pb-1 tw-pl-0"
}, D = {
  md: "tw-h-[49.178px] tw-w-[55.611px]",
  sm: "tw-h-[35.13px] tw-w-[39.72px]",
  xs: "tw-h-[21.08px] tw-w-[23.83px]"
}, f = {
  md: "tw-size-40",
  sm: "tw-size-[28.57px]",
  xs: "tw-size-[17.14px]"
}, L = [{
  translateX: "-47%",
  translateY: "-57%",
  rotateDeg: 2,
  overlay: !1
}, {
  translateX: "-60%",
  translateY: "-50%",
  rotateDeg: -10,
  overlay: !1
}, {
  translateX: "-38%",
  translateY: "-43%",
  rotateDeg: 8,
  overlay: !0
}], b = [2, 1, 0], g = "tw-size-full tw-shrink-0 tw-bg-gray-200 tw-bg-cover tw-bg-center tw-bg-no-repeat", X = {
  sm: "-1.161px",
  md: "-1.626px"
}, O = (s) => [...s].reverse(), v = (s, a) => {
  const e = `url(${JSON.stringify(s)})`;
  return {
    backgroundImage: a ? `linear-gradient(0deg, rgba(18, 18, 18, 0.3) 0%, rgba(18, 18, 18, 0.3) 100%), ${e}` : e
  };
}, Y = (s, a) => {
  const e = `url(${JSON.stringify(s)})`, o = X[a];
  return {
    backgroundImage: e,
    backgroundColor: "#d3d3d3",
    backgroundPosition: `0px ${o}`,
    backgroundSize: "100% 149.982%",
    backgroundRepeat: "no-repeat"
  };
}, P = (s) => {
  if (s == null) return null;
  if (typeof s == "string") {
    const e = s.trim();
    return e ? [e] : null;
  }
  const a = s.map((e) => String(e).trim()).filter(Boolean).slice(0, 3);
  return a.length > 0 ? a : null;
}, R = ({
  alt: s,
  className: a,
  sizeKey: e,
  urls: o
}) => {
  const x = o.length, l = j[e], c = e === "md" ? "md" : "sm";
  if (x === 1) {
    const i = o[0], r = !!s;
    return /* @__PURE__ */ t.jsx("div", { className: w("tw-box-border tw-flex tw-shrink-0 tw-items-center tw-justify-center", _[c], a), children: /* @__PURE__ */ t.jsx("div", { className: w("tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4", y[c]), children: /* @__PURE__ */ t.jsx("div", { className: g, style: v(i, !1), role: r ? "img" : void 0, "aria-label": r ? s : void 0, "aria-hidden": r ? void 0 : !0 }) }) });
  }
  const m = O(o);
  return x === 3 ? /* @__PURE__ */ t.jsx("div", { className: w("tw-box-border tw-shrink-0", B[e], l, a), children: /* @__PURE__ */ t.jsx("div", { className: w("tw-relative tw-shrink-0", D[e]), children: m.map((i, r) => {
    const n = L[r], d = b[r] === 2 && !!s;
    return /* @__PURE__ */ t.jsx("div", { className: w("tw-absolute tw-left-1/2 tw-top-1/2 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4 tw-border tw-border-solid tw-border-base-white", f[e]), style: {
      zIndex: b[r],
      transform: `translate(${n.translateX}, ${n.translateY}) rotate(${n.rotateDeg}deg)`
    }, children: /* @__PURE__ */ t.jsx("div", { className: g, style: v(i, n.overlay), "aria-hidden": d ? void 0 : !0, role: d ? "img" : void 0, "aria-label": d ? s : void 0 }) }, `${i}-${r}`);
  }) }) }) : /* @__PURE__ */ t.jsx("div", { className: w("tw-box-border tw-shrink-0", T[e], l, a), children: /* @__PURE__ */ t.jsx("div", { className: w("tw-relative tw-shrink-0 tw-overflow-visible", $[e]), children: m.map((i, r) => {
    const n = E[r], d = u[r] === 1 && !!s;
    return /* @__PURE__ */ t.jsx("div", { className: w("tw-absolute tw-left-1/2 tw-top-1/2 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4 tw-border tw-border-solid tw-border-base-white", f[e]), style: {
      zIndex: u[r],
      transform: `translate(${n.translateX}, ${n.translateY}) rotate(${n.rotateDeg}deg)`
    }, children: /* @__PURE__ */ t.jsx("div", { className: g, style: v(i, n.overlay), "aria-hidden": d ? void 0 : !0, role: d ? "img" : void 0, "aria-label": d ? s : void 0 }) }, `${i}-${r}`);
  }) }) });
}, U = ({
  alt: s,
  avatarAlt: a,
  avatarUrl: e,
  className: o,
  mediaUrl: x,
  singleSizeKey: l
}) => {
  const c = !!s, m = !!a;
  return /* @__PURE__ */ t.jsx("div", { className: w(A[l], o), children: /* @__PURE__ */ t.jsxs("div", { className: C[l], children: [
    /* @__PURE__ */ t.jsx("div", { className: "tw-absolute tw-left-0 tw-top-0", children: /* @__PURE__ */ t.jsx("div", { className: w("tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4", y[l]), children: /* @__PURE__ */ t.jsx("div", { className: g, style: v(x, !1), role: c ? "img" : void 0, "aria-label": c ? s : void 0, "aria-hidden": c ? void 0 : !0 }) }) }),
    /* @__PURE__ */ t.jsx("div", { className: M[l], children: /* @__PURE__ */ t.jsx("div", { className: "tw-size-full tw-shrink-0 tw-rounded-circular", style: Y(e, l), role: m ? "img" : void 0, "aria-label": m ? a : void 0, "aria-hidden": m ? void 0 : !0 }) })
  ] }) });
}, W = I.forwardRef((s, a) => {
  const {
    alt: e = "",
    avatar: o,
    avatarAlt: x = "",
    className: l,
    icon: c,
    media: m,
    size: i = "md"
  } = s, r = P(m), n = r != null, p = !n && c != null, d = !!(n && o?.trim()), h = n && i === "xs" ? "sm" : i, k = h === "md" ? "md" : "sm", z = !!(r?.length === 1 && d);
  return !n && !p ? null : p ? /* @__PURE__ */ t.jsx("div", { ref: a, "data-slot": "media-tile", "data-variant": "icon", "data-size": i, className: w("tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4 tw-bg-gray-200", S[i], j[i], l), children: c }) : /* @__PURE__ */ t.jsx("div", { ref: a, "data-slot": "media-tile", "data-variant": "media", "data-size": h, className: w("tw-relative tw-inline-flex tw-shrink-0", l), children: z ? /* @__PURE__ */ t.jsx(U, { alt: e, avatarAlt: x, avatarUrl: o.trim(), mediaUrl: r[0], singleSizeKey: k }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(R, { alt: e, sizeKey: h, urls: r }),
    d && /* @__PURE__ */ t.jsx("div", { className: w("tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-z-20 tw-translate-x-1 tw-translate-y-1 tw-overflow-hidden tw-rounded-circular tw-border-2 tw-border-base-white tw-bg-gray-200 tw-shadow-sm", N[h]), children: /* @__PURE__ */ t.jsx("img", { src: o.trim(), alt: x, className: "tw-size-full tw-object-cover", loading: "lazy" }) })
  ] }) });
});
W.displayName = "MediaTile";
export {
  X as A,
  J as I,
  W as M,
  q as a,
  N as b,
  _ as c,
  y as d,
  A as e,
  C as f,
  M as g,
  $ as h,
  S as i,
  E as j,
  u as k,
  B as l,
  D as m,
  P as n,
  f as o,
  L as p,
  b as q,
  g as r,
  j as s,
  T as t
};
//# sourceMappingURL=MediaTile.DaLJeauY.js.map
